var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-file-input',{staticStyle:{"display":"none"},attrs:{"id":"aInput"},model:{value:(_vm.Selected),callback:function ($$v) {_vm.Selected=$$v},expression:"Selected"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }